export default "__VITE_ASSET__Bq_pix3g__"